import React, { Component } from 'react';
//import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Form, Input, Button, Row, Col, message } from 'antd';
import PropTypes from 'prop-types';
import { EyeTwoTone, EyeInvisibleOutlined, LockOutlined } from '@ant-design/icons';
import { fetchServer } from '../Base/modelManager';
import { Link } from 'react-router-dom';
import { serverError } from '../../redux/actions/serverManagerAction';




class ResetPassword extends Component {

    constructor(props) {
        super(props);
        this.state = {
            confirm: '',
            password: '',
            token: '',
            processed: false
        }
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentDidMount() {
        const queryParams = new URLSearchParams(window.location.search)
        const token = queryParams.get("token")
        this.setState({ token: token })
    }

    handleInputChange(e) {
        this.setState({
            [e.target.name]: e.target.value
        })
    }

    handleSubmit(values) {
        //e.preventDefault();
        if (values.password !== values.confirm) {
            message.error('le mot de passe et la conrifmation ne correspondent pas', 5)
            return
        }
        values.token = this.state.token
        const request = {
            endPoint: this.props.authUrl + '/resetPasswordClient',
            method: 'POST',
            params: values,
        }

        fetchServer(request,
            () => {
                this.setState({
                    processed: true
                })
            },
            error => this.props.dispatch(serverError(error))
        )

    }


    onBlur = () => {
        this.setState({ capswarning: false });

    }


    onKeyDown = keyEvent => {
        if (keyEvent.getModifierState("CapsLock")) {
            this.setState({ capswarning: true });
        } else {
            this.setState({ capswarning: false });
        }
    };

    render() {
        //const { errors } = this.state;
        //const { getFieldDecorator } = this.props.form;



        if (this.state.processed === true)
            return (
                <div className='container' style={{ margin: '0 auto', width: '400px', height: '320px' }}>
                    <p>Le mot de passe a bien été réinitialisé</p>
                    <Link onClick={() => window.close()}>Fermer la Page</Link>
                </div>
            )
        else

            return (
                <div className='container' style={{ margin: '0 auto', width: '400px', height: '320px' }}>
                    <h2 style={{ marginBottom: '40px' }}>Réinitialiser mon mot de passe</h2>
                    <Form onFinish={this.handleSubmit} className='ResetPassword-form'>
                        <Form.Item name='password' rules={[{ required: true, message: 'Entrez votre mot nouveau de passe!' }]}>
                            <Input.Password
                                prefix={<LockOutlined style={{ color: 'rgba(0,0,0,.25)' }} />}

                                placeholder='Nouveau mot de passe'
                                onChange={this.handleInputChange}
                                iconRender={(visible) => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)}
                                name='password'
                            />
                        </Form.Item>
                        <Form.Item name='confirm' rules={[{ required: true, message: 'Entrez votre la confirmation du mot de passe!' }]}>
                            <Input.Password
                                prefix={<LockOutlined style={{ color: 'rgba(0,0,0,.25)' }} />}

                                placeholder='Confirmation'
                                onChange={this.handleInputChange}
                                iconRender={(visible) => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)}
                                name='confirm'
                            />
                        </Form.Item>
                        <Form.Item>
                            <Row>
                                <Col span={6}>
                                    <Button type='primary' htmlType='submit' className='ResetPassword-form-button'>
                                        Enregistrer
                                    </Button>
                                </Col>

                            </Row>
                        </Form.Item>
                    </Form>
                </div>
            )
    }
}



const mapStateToProps = state => {
    return {
        error: state.authentication.error,
        authorized: state.authentication.authorized,
        authUrl: state.server.authUrl,
    }
}
ResetPassword.propTypes = {
    error: PropTypes.any,
    dispatch: PropTypes.func,
    form: PropTypes.any,
    authorized: PropTypes.bool,
    authUrl: PropTypes.string,
    JWTToken: PropTypes.string
};

export default connect(mapStateToProps)(ResetPassword)